;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  angular.module('app.core').config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('home', {
      url: '/',
      parent: 'portal',
      templateUrl: 'home.html',
      controller: 'Home',
      controllerAs: '$ctrl',
      public: true,
    })
  }
})()
